import { differenceInSeconds } from 'date-fns'
import { useSelector } from 'react-redux'
import { selectACWByID } from 'store/acw/acw.selectors'

export default function useACWTimeLeft(contactID?: string): number | null {
    const acw = useSelector(selectACWByID(contactID))

    if (!acw || acw.extendedAt || acw.durationSeconds === undefined) return null

    const timeLeftInSeconds = acw.durationSeconds - differenceInSeconds(Date.now(), acw.startedAt)

    return timeLeftInSeconds > 0 ? timeLeftInSeconds : null
}
